import { render, staticRenderFns } from "./inputTags.vue?vue&type=template&id=2c9caee2&"
import script from "./inputTags.vue?vue&type=script&lang=js&"
export * from "./inputTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports